import { Table } from 'antd';
import React from 'react';

import './style.less';

const FinancialInfoTable = ({ columns, rows, loading }) => {
  return (
    <Table
      className="KYB-financial-info-table"
      columns={columns}
      dataSource={rows}
      pagination={false}
      loading={loading}
      size="small"
    />
  );
};

export default FinancialInfoTable;
